import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { CompanyService } from '../../../services/company.service';
import { StorefrontService } from '../../../services/storefront.service';
import { Subject, takeUntil, filter } from 'rxjs';
import { QrCodeCardComponent } from '../../../components/qr-code-card/qr-code-card.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideExternalLink, lucideQrCode } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';

@Component({
  selector: 'app-qr-code-settings',
  standalone: true,
  imports: [QrCodeCardComponent, NgIcon, HlmAlertImports],
  providers: [
    provideIcons({
      lucideExternalLink,
      lucideQrCode,
    }),
  ],
  templateUrl: './qr-code-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./qr-code-settings.component.css'],
})
export class QrCodeSettingsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  companyName: string = '';
  storefrontUrl: string = '';
  suburl: string | null = null;

  constructor(
    private companyService: CompanyService,
    private storefrontService: StorefrontService,
  ) {
    this.suburl = this.companyService.getCurrentCompany()?.suburl || null;
  }

  ngOnInit() {
    this.companyService.company$
      .pipe(
        takeUntil(this.destroy$),
        filter((company) => company !== null),
      )
      .subscribe((company) => {
        if (company) {
          this.companyName = company.name;
          this.suburl = company.suburl;
          this.storefrontUrl = this.getStorefrontUrl();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Gets the full storefront URL for the current environment
   */
  private getStorefrontUrl(): string {
    if (!this.suburl) {
      return '#';
    }

    const baseDomain = this.storefrontService.getStorefrontBaseDomain();
    const protocol = this.storefrontService.getProtocol();
    return `${protocol}${this.suburl}.${baseDomain}`;
  }

  /**
   * Gets the display URL (without protocol) for the current environment
   */
  getStorefrontDisplayUrl(): string {
    if (!this.suburl) {
      return '';
    }

    const baseDomain = this.storefrontService.getStorefrontBaseDomain();
    const protocol = this.storefrontService.getProtocol();
    return `${protocol}${this.suburl}.${baseDomain}`;
  }
}
